module.exports = __webpack_public_path__ + "static/media/sn-2000bt.ca497035.jpg";